// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// Standard js librairires (imported globally)
import '../node_modules/aos/dist/aos.css'
import aos from 'aos'
import 'izitoast/dist/css/iziToast.min.css'
import iZtoast from 'izitoast'

// Vue Libs / Plugins
import Axios from 'axios'
import VueMasonry from 'vue-masonry-css'
import VueSilentbox from 'vue-silentbox'

// Import and set axios configuration
Vue.prototype.axios = Axios
Vue.prototype.axios.defaults.baseURL = 'https://adm.komachi.pomzed.ch'
Vue.prototype.axios.interceptors.response.use(
  /**
   * Get response when axiox call has no errors
   * @param {*} response
   * @return response
   */
  function (response) {
    return response
  },
  /**
   * Catch error globally
   * @param {*} error
   * @return message
   */
  function (error) {
    if (error) {
      return iZtoast.error({
        title: 'Un problème est survenu, merci de rééssayer plus tard.',
        message: error,
        timeout: false,
        position: 'bottomCenter'
      })
    }
  }
)

// Initialize Vuejs plugins
Vue.use(VueMasonry)
Vue.use(VueSilentbox)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// Initialize aos.js
aos.init()



// WEBPACK FOOTER //
// ./src/main.js